import React from 'react';
import { useBooking } from '../../context/BookingContext';
import './TripTypeSelector.css';

const TRIP_TYPES = [
  { id: 'instant', label: 'Instant', icon: '⚡' },
  { id: 'rental', label: 'Rental', icon: '🕐' },
  { id: 'outstation', label: 'Outstation', icon: '🛣️' },
];

const TripTypeSelector = () => {
  const { booking, updateBooking } = useBooking();

  return (
    <div className="tt-selector">
      <div className="tt-tabs" role="tablist">
        {TRIP_TYPES.map((t) => {
          const active = booking.tripType === t.id;
          return (
            <button
              key={t.id}
              role="tab"
              aria-selected={active}
              className={`tt-tab ${active ? 'active' : ''}`}
              onClick={() => {
                updateBooking('tripType', t.id);
                updateBooking('selectedPackage', null);
                updateBooking('selectedVehicle', null);
                updateBooking('date', '');
                updateBooking('pickupTime', '');
                updateBooking('dropDate', '');
                updateBooking('dropTime', '');
                updateBooking('booking', null);
                updateBooking('payment', null);
                updateBooking('paymentVerification', null);
              }}
            >
              <span className="tt-icon" aria-hidden>{t.icon}</span>
              <span>{t.label}</span>
            </button>
          );
        })}
      </div>

      {booking.tripType === 'outstation' && (
        <div className="tt-subtabs" role="tablist" aria-label="Outstation mode">
          {['one_way', 'round_trip'].map((m) => (
            <button
              key={m}
              role="tab"
              aria-selected={booking.rideMode === m}
              className={`tt-subtab ${booking.rideMode === m ? 'active' : ''}`}
              onClick={() => {
                updateBooking('rideMode', m);
                updateBooking('selectedPackage', null);
                updateBooking('booking', null);
                updateBooking('payment', null);
                updateBooking('paymentVerification', null);
              }}
            >
              {m === 'one_way' ? 'One-way' : 'Round Trip'}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default TripTypeSelector;